import { useCallback, useEffect, useState } from 'react'
import { fetchPeopleReader, type PeopleReader } from '../api/peopleReader'

export function usePeopleReader(publicId?: string) {
  const [data, setData] = useState<PeopleReader | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(() => {
    if (!publicId) return
    let cancelled = false
    setLoading(true)
    setError(null)
    fetchPeopleReader(publicId)
      .then((d) => { if (!cancelled) setData(d) })
      .catch((e) => { if (!cancelled) setError(e?.message || 'Failed to load profile') })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [publicId])

  useEffect(() => {
    const cancel = reload()
    return () => { if (cancel) cancel() }
  }, [reload])

  return { data, loading, error, reload }
}
